import { helper } from '@ember/component/helper';
import { pledgeFrequencyLabels } from 'donor-elf-web/lib/pledge-utils';

export default helper(function ([pledgeFrequency]: string[]) {
  return pledgeFrequencyLabels[pledgeFrequency];
});
